// @ts-nocheck


export const Features = {
  Warehouses: 'warehouses',
  Branches: 'branches',
  ManualJournal: 'manualJournal',
  Projects: 'projects',
  BankSyncing: 'BankSyncing',
  Funds: 'funds',
}